<template>
  <label class="base-toggle">
    <span v-if="label" class="base-toggle__label">{{ label }}</span>
    <input
      v-bind="$attrs"
      type="checkbox"
      :checked="checked"
      class="base-toggle__input"
      @change="change"
    />
    <span class="base-toggle__slider" />
  </label>
</template>

<script setup>
defineProps({
  checked: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    required: false,
    default: '',
  },
})
const emit = defineEmits(['onChange', Boolean])

const change = (event) => {
  emit('onChange', event.target.checked)
}
</script>

<style scoped lang="scss">
.base-toggle {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: $spacing-4xs;
  cursor: pointer;
  user-select: none;

  &__label {
    @include formLabelStyle;
  }

  &__input {
    display: none;
  }

  &__slider {
    width: 40px;
    height: 20px;
    background: $color-steel;
    border-radius: 100px;
    position: relative;
    transition: background-color 200ms ease-in-out;
    margin-right: 8px;
    box-sizing: border-box;
  }

  &__slider::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 3px;
    width: 14px;
    height: 14px;
    background: $color-canvas;
    border-radius: 50%;
    transition: transform 200ms ease-in-out;
  }
}

.base-toggle__input:checked + .base-toggle__slider {
  background: $color-navigation;

  &::before {
    transform: translateX(18px);
  }
}

.base-toggle__input:disabled {
  &:not(checked) + .base-toggle__slider {
    cursor: not-allowed;
    background: $color-marble;
  }

  &:checked + .base-toggle__slider {
    cursor: not-allowed;
    background-color: $color-blue-45;
    opacity: 0.3;
  }
}
</style>
